// Whether the GESTURE route-transition engine should skip its animation and cut straight to the target. Two
// triggers, read the SAME way at every gating site so the controller and its edge-swipe agree on when a move is
// animated:
//   • prefers-reduced-motion — the user/OS asked for no motion.
//   • a mouse-primary (desktop) pointer — the gesture is a pointer-DRAG affordance: an edge-swipe is meaningless
//     with a mouse, and the link-slide it shares reads as unwanted chrome on the desktop. `(pointer: fine)`
//     means the primary pointer is a mouse/trackpad; a phone or tablet reports `(pointer: coarse)` and keeps it.
//
// The scroll-snap engine is deliberately NOT gated this way: it is driven by native scroll (wheel / trackpad),
// which a desktop user can still perform, so it stays live on a fine pointer (see scroll-transition-outlet.tsx).
//
// Only ever called from effects / event handlers, never during render — so the SSR tree stays byte-identical to
// a bare <Outlet/> and these client-only media reads carry no hydration hazard.
export function transitionsSuppressed(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.matchMedia('(pointer: fine)').matches
}
